<template>
  <div class="app-container cheliang-page">
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-select v-if="useApi" v-model="communityId" filterable clearable placeholder="选择项目（可选）" size="mini" style="width:220px">
          <el-option v-for="item in communityOptions" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-input v-model="plate" size="mini" placeholder="请输入完整车牌号，或片段搜索" clearable @keyup.enter.native="queryStatus" />
      </div>
      <div v-if="plateCandidates.length" class="shaixuan-item candidate-select">
        <el-select
          v-model="selectedCandidateKey"
          filterable
          clearable
          size="mini"
          placeholder="匹配到多个车牌，请选择"
          style="width:320px"
          @change="onCandidateSelect"
        >
          <el-option
            v-for="item in plateCandidates"
            :key="candidateKey(item)"
            :label="formatCandidateLabel(item)"
            :value="candidateKey(item)"
          />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-button type="primary" size="mini" class="btn-primary-blue" icon="el-icon-search" :loading="loading" @click="queryStatus">查询</el-button>
      </div>
    </div>
    <div v-if="useHikApi" class="common-section-bg" style="padding: 0 16px 12px">
      <el-alert title="状态查询需完整车牌号；可输入片段搜索本地车辆后选择，再查询海康在库状态" type="info" show-icon :closable="false" />
    </div>
    <div v-if="useJwsApi" class="common-section-bg" style="padding: 0 16px 12px">
      <el-alert title="根据捷卫士进出场记录判断是否在库；可直接输入车牌查询，无需先录入本地车辆" type="info" show-icon :closable="false" />
    </div>
    <div class="common-section-bg" style="padding: 12px 16px" v-if="statusInfo">
      <el-descriptions :column="2" border size="mini">
        <el-descriptions-item label="车牌号">{{ statusInfo.plate }}</el-descriptions-item>
        <el-descriptions-item label="是否在库">
          <el-tag :type="statusInfo.in_garage === '是' ? 'success' : 'info'" size="mini">{{ statusInfo.in_garage }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="业主">{{ statusInfo.owner || '—' }}</el-descriptions-item>
        <el-descriptions-item label="车位">{{ statusInfo.parking_space || '—' }}</el-descriptions-item>
        <el-descriptions-item label="业主房号">{{ statusInfo.room_no || '—' }}</el-descriptions-item>
        <el-descriptions-item v-if="useApi" :label="expireDateLabel">{{ statusInfo.hik_expire_date || statusInfo.jws_expire_date || '—' }}</el-descriptions-item>
        <el-descriptions-item v-if="useApi && statusInfo.fee_expire_date" label="车位费有效期">{{ statusInfo.fee_expire_date }}</el-descriptions-item>
        <el-descriptions-item v-if="useJwsApi && statusInfo.person_code" label="人员编码">{{ statusInfo.person_code }}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div v-if="useApi" class="common-section-bg common-section-body table-wrap">
      <div class="section-title" style="padding: 8px 0">出入记录</div>
      <el-table v-loading="recordsLoading" :data="records" size="mini" style="width: 100%; min-height: 260px">
        <el-table-column prop="plate" label="车牌号" width="110" />
        <el-table-column prop="direction" label="方向" width="70" />
        <el-table-column prop="gate" label="通道" min-width="120" show-overflow-tooltip />
        <el-table-column prop="time" label="时间" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">{{ formatDateTime(scope.row.time) }}</template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="recordsTotal > 0"
        :total="recordsTotal"
        :page.sync="recordsQuery.page"
        :limit.sync="recordsQuery.size"
        @pagination="loadCrossRecords"
      />
      <el-empty v-if="queried && !recordsLoading && !records.length" description="暂无出入记录" :image-size="80" />
    </div>
  </div>
</template>

<script>
import { hikVehicles, jwsVehicles, accessRecords } from '../mockData'
import chechangHikVehicle from '@/api/tianzheng/chechangHikVehicle'
import chechangJwsVehicle from '@/api/tianzheng/chechangJwsVehicle'
import { parseTime } from '@/utils'
import Pagination from '@/components/Pagination'

export default {
  name: 'VehicleStatusPage',
  components: { Pagination },
  props: {
    title: { type: String, default: '' },
    source: { type: String, default: 'hik' },
    useHikApi: { type: Boolean, default: false },
    useJwsApi: { type: Boolean, default: false }
  },
  data() {
    return {
      plate: '',
      statusInfo: null,
      records: [],
      communityId: null,
      communityOptions: [],
      plateCandidates: [],
      selectedCandidateKey: '',
      loading: false,
      recordsLoading: false,
      recordsTotal: 0,
      recordsQuery: { page: 1, size: 10 },
      queried: false
    }
  },
  computed: {
    useApi() {
      return this.useHikApi || this.useJwsApi
    },
    vehicleApi() {
      return this.useJwsApi ? chechangJwsVehicle : chechangHikVehicle
    },
    expireDateLabel() {
      if (this.useJwsApi) return '捷卫士有效期'
      if (this.useHikApi) return '海康车辆有效期'
      return '有效期'
    }
  },
  mounted() {
    if (this.useApi) {
      this.vehicleApi.communitySelect().then(res => {
        if (res.code === 200) {
          this.communityOptions = (res.result || []).map(item => ({
            ...item,
            id: Number(item.id)
          }))
        }
      })
    } else {
      this.plate = '冀TA12345'
      this.queryStatus()
    }
  },
  methods: {
    formatDateTime(time) {
      if (!time) return '—'
      if (typeof time === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(time)) {
        return time
      }
      return parseTime(time) || time
    },
    candidateKey(item) {
      return `${item.community_id || 0}:${item.plate}`
    },
    formatCandidateLabel(item) {
      const parts = [item.plate]
      if (item.owner) parts.push(item.owner)
      if (item.project) parts.push(item.project)
      return parts.join(' - ')
    },
    ensureCommunityOption(communityId, name = '') {
      const id = Number(communityId)
      if (!id) {
        this.communityId = null
        return
      }
      if (!this.communityOptions.some(item => Number(item.id) === id)) {
        this.communityOptions = [
          { id, name: name || `小区#${id}` },
          ...this.communityOptions
        ]
      }
      this.communityId = id
    },
    onCandidateSelect(key) {
      if (!key) return
      const candidate = this.plateCandidates.find(item => this.candidateKey(item) === key)
      if (!candidate) return
      this.plate = candidate.plate
      this.ensureCommunityOption(candidate.community_id, candidate.project)
      this.plateCandidates = []
      this.selectedCandidateKey = ''
      this.queryStatus()
    },
    getRecordsCommunityId() {
      if (this.communityId) return Number(this.communityId)
      if (this.statusInfo && this.statusInfo.community_id) return Number(this.statusInfo.community_id)
      return null
    },
    applyRecordsResult(result) {
      this.records = (result && result.list) || []
      this.recordsTotal = (result && result.total) || 0
    },
    loadCrossRecords() {
      if (!this.useApi || !this.plate || !this.statusInfo) return
      const communityId = this.getRecordsCommunityId()
      if (!communityId) {
        this.$message.warning('缺少小区信息，无法加载出入记录')
        return
      }
      this.recordsLoading = true
      this.vehicleApi.statusCrossRecordsByPlate({
        plate_no: this.plate.trim(),
        community_id: communityId,
        page: this.recordsQuery.page,
        size: this.recordsQuery.size
      }).then(res => {
        this.recordsLoading = false
        if (res.code === 200) {
          this.applyRecordsResult(res.result)
        }
      }).catch(() => {
        this.recordsLoading = false
      })
    },
    queryStatus() {
      if (this.useApi) {
        if (!this.plate) {
          this.$message.warning('请输入车牌号')
          return
        }
        this.loading = true
        this.queried = true
        this.plateCandidates = []
        this.selectedCandidateKey = ''
        this.recordsQuery.page = 1
        const params = {
          plate_no: this.plate.trim(),
          page: this.recordsQuery.page,
          size: this.recordsQuery.size
        }
        if (this.communityId) {
          params.community_id = this.communityId
        }
        this.vehicleApi.statusByPlate(params).then(res => {
          this.loading = false
          if (res.code !== 200) {
            this.statusInfo = null
            this.records = []
            this.recordsTotal = 0
            return
          }
          if (res.result && res.result.mode === 'candidates') {
            this.statusInfo = null
            this.records = []
            this.recordsTotal = 0
            this.plateCandidates = res.result.candidates || []
            if (!this.plateCandidates.length) {
              this.$message.warning('未找到匹配车辆')
            } else {
              this.$message.info('匹配到多个车牌，请选择后继续查询')
            }
            return
          }
          this.statusInfo = res.result.status
          this.applyRecordsResult(res.result.records)
          if (this.statusInfo && this.statusInfo.community_id) {
            this.ensureCommunityOption(this.statusInfo.community_id, this.statusInfo.project)
          }
        }).catch(err => {
          this.loading = false
          this.$message.error(err || '查询失败')
        })
        return
      }
      const pool = this.source === 'hik' ? hikVehicles : jwsVehicles
      const found = pool.find(item => item.plate === this.plate) || pool[0]
      this.statusInfo = found
      this.records = accessRecords.filter(item => item.plate === found.plate)
      if (!this.records.length) this.records = accessRecords.slice(0, 2)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/page.scss';
</style>
